module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAApBAMAAADdf/TDAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUxpcY6OjpSUlJSUlJOTk5SUlJSUlJOTk5KSkpOTk5SUlJSUlJOTk5SUlJOTk5SUlObHaMwAAAAPdFJOUwAED3dU9tPoHrY0nr6VOY+cWtYAAACASURBVCjPddJRDYAgFIVhIxDBCEQwhCHIwJMZSGAFKtjABnZwypi669SpPw+Xt2+McTiXaqywcg2II1IPSEuIJQ4DSCDWDhBPLA0gMyGR2GvgifgiTcAd8cMV8cdmABmIrO0UZ6xyT5HAaamj8tKiA6/1FrSurTKfYnJOmzb/wQlv3/whk9I/vwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/arrow.png
// module id = IHch
// module chunks = 38